<img #img class="bg" [src]="src" />
<div class="location-gradient"></div>
<div class="location" *ngIf="location.length>0"><span class="icon"></span><span [innerHTML]="location"></span></div>
